import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// h5share 及分享下载页面需要h5share 和首页配置/pages/downloadApp/并且显示#
const constantRoutes=[
  {
    // path: '/pages/downloadApp/',
    path:'/',
    component: (resolve) => require(['@/views/upload'], resolve),
    hidden: true,
    meta:{
      title:'德方云APP下载'
    }
  },
  {
    path: '/article',
    component: (resolve) => require(['@/views/article'], resolve),
    hidden: true,
    meta:{
      title:'百科详情'
    }
  },
  {
    path: '/privacy',
    component: (resolve) => require(['@/views/privacy'], resolve),
    hidden: true,
    meta:{
      title:'隐私政策'
    }
  },
  {
    path: '/agreement',
    component: (resolve) => require(['@/views/agreement'], resolve),
    hidden: true,
    meta:{
      title:'用户协议'
    }
  },
  {
    path: '/share',
    component: (resolve) => require(['@/views/share'], resolve),
    hidden: true,
    meta:{
      title:'图片生成中'
    }
  },
  {
    path: '/shareBlack',
    component: (resolve) => require(['@/views/shareBlack'], resolve),
    hidden: true,
    meta:{
      title:'图片生成中'
    }
  },
]
export default new Router({
  mode: 'history', // 去掉url中的#
  // base:'/h5share/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
